<template>
  <component :is="show ? 'panel-element' : 'panel-element-hidden'" :data-main-type="mainQuestion.type">
    <fieldset>
      <legend v-if="hasTitle">{{ mainQuestion.title.get() }}</legend>

      <div class="panel-inner" :data-extra-content="!!((mainQuestion.notes && mainQuestion.notes[getLocale()]) || (mainQuestion.resources && mainQuestion.resources[getLocale()]))">

        <div class="main">
          <question-component @update-show="updateShow" :question="mainQuestion" />
          <question-component :question="question" v-for="question in questions"/>
        </div>

        <div class="extra">
          <div class="extra-item" v-if="mainQuestion.notes && mainQuestion.notes[getLocale()]">
            <div class="extra-item-heading">
              <div class="extra-item-heading-label">{{$t('notes')}}</div>
            </div>
            <div ref="notes" class="notes-text extra-item-content" @click="onNotesClick" v-html="mainQuestion.notes.get()" />
          </div>
          <div class="extra-item" v-if="mainQuestion.resources && mainQuestion.resources[getLocale()]">
            <div class="extra-item-heading">
              <div class="extra-item-heading-label">{{$t('resources')}}</div>
            </div>
            <div class="resources-text extra-item-content" v-html="mainQuestion.resources.get()" />
          </div>
          <QuestionNoteCollectionComponent :question-id="mainQuestion.id" :page-id="page.id" :submission-id="submissionId" />
        </div>

      </div>
    </fieldset>
  </component>
</template>

<script lang="ts" setup>
import QuestionComponent from './Question/QuestionComponent.vue';
import QuestionNoteCollectionComponent from './QuestionNote/QuestionNoteCollectionComponent.vue';
import { ref, inject, onMounted, onUnmounted } from "vue";
import Manager from '../../../core/Manager';
import { getLocale} from '../../../core/Utils';
const props = defineProps({
  panel: Array
});

const questions = [...props.panel];
const mainQuestion: any = questions.shift();
const hasTitle = mainQuestion.title;
const submissionId = Manager.getInstance().submission.id;
const page = inject('page');
const notes = ref();

const show = ref(true);

const updateShow = (questionComponentShow) => {
  show.value = questionComponentShow.value;
};

const onNotesClick = (e) => {
  if(e.target.classList.contains('show-help-button')) {
    notes.value?.classList.toggle('show-help');
  }
}
</script>
